import { getLayoutState, useSelector } from '../store'
import AccountMenu from './AccountMenu'
import './Maincontainer.css'
import SubscriptionPlanBanner from './SubscriptionPlanBanner'

export interface MainContainerProps {
  children: any
}

const MainContainer = ({ children = [] }: MainContainerProps) => {
  const { sideBarCollapsed } = useSelector(getLayoutState)
  return (
    <div>
      <div
        style={{
          height: '80px',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 15,
          backgroundColor: '#2E2F3C',
        }}
      >
        <div className="mainHeaderBanner">
          <SubscriptionPlanBanner />
          <AccountMenu />
        </div>
      </div>

      <div
        className={`main-content${
          !sideBarCollapsed ? ' sidebar-expanded' : ''
        }`}
      >
        {children}
      </div>
    </div>
  )
}

export default MainContainer
